/*----- Core -----*/
import styled from 'styled-components'

/*----- Commons -----*/
import Color  from '../../../../commons/Color'

export default styled.main`

	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;

	.update-product__delete-btn {
		margin-top: 128px;
		padding-top: 32px;
		border-top: 1px solid ${ Color.actions.danger };
	}

	.update-producer__delete-btn {
		margin-top: 128px;
		padding-top: 32px;
		border-top: 1px solid ${ Color.actions.danger };
	}
	
`